export default __webpack_public_path__ + "static/media/Buttons.06a1d67a.png";